export default "__VITE_ASSET__4dJU6__e__"